import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { loadOnlyAvatarVidboardAvatars } from "../../thunks/editor/avatarThunks";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faClose,
} from "@fortawesome/free-solid-svg-icons";
import { Modal } from "../common/modal";
import { generateNewIdAndNavigate } from "../../thunks/dashboardThunks";
import { useNavigate } from "react-router-dom";
import { DEFAULT_PROJECT_NAMES } from "../../constants/general";

import { CanvasContext } from "../editor/CanvasContext";
import {
  setIsDoc,
  setIsLink,
  setIsOnlyAvatar,
  setIsOnlyAvatarUrl,
} from "../../store/project/projectSlice";

const AvatarSlider = () => {
  const dispatch = useDispatch();
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const { canvas } = useContext(CanvasContext);
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const scrollContainer = useRef(null);
  const scrollRight = () => {
    if (scrollContainer.current) {
      scrollContainer.current.scrollBy({ left: 150, behavior: "smooth" });
    }
  };
  const scrollLeft = () => {
    if (scrollContainer.current) {
      scrollContainer.current.scrollBy({ left: -150, behavior: "smooth" });
    }
  };
  const onToggle = () => setIsModalOpen((prev) => !prev);
  useEffect(() => {
    dispatch(loadOnlyAvatarVidboardAvatars());
  }, []);
  const onAvatarClick = () => {
    dispatch(setIsDoc(false));
    dispatch(setIsLink(false));
    dispatch(
      setIsOnlyAvatarUrl({ ...selectedAvatar, url: selectedAvatar?.image })
    );
    dispatch(
      generateNewIdAndNavigate(
        navigate,
        "/tool/editor/" + "only-avatar" + "/",
        DEFAULT_PROJECT_NAMES["only-avatar"],
        false,
        false,
        null,
        null,
        undefined,
        true
      )
    );
  };
  const { backgroundAvatars } = useSelector((state) => state.avatars);

  return (
    <>
      <Modal
        size="lg"
        hideClose
        center
        confirmText="Continue"
        cancelText="Cancel"
        open={isModalOpen}
        onSubmit={async () => {
          onAvatarClick();
        }}
        onClose={() => onToggle()}
        classes={{
          wrapper: "!z-50",
          body: "!z-50",
          backdrop: "!z-50",
        }}
      >
        <FontAwesomeIcon
          icon={faClose}
          onClick={() => onToggle()}
          className="absolute top-5 right-5 cursor-pointer"
        ></FontAwesomeIcon>
        <div className="flex justify-end w-full gap-2 ">
          If you select an avatar from the only avatar section, then you will
          not be able to create presenter led videos. If you want to create AI
          presenter led videos then please click on Create Video with avatar.
        </div>
      </Modal>
      <span>Only Avatars</span>
      <div className="flex justify-center items-center pt-2">
        <span
          className="text-gray-400 cursor-pointer mr-2"
          onClick={scrollLeft}
        >
          <FontAwesomeIcon
            icon={faArrowAltCircleLeft}
            className="mr-2 text-gray-800 hover:text-vb-pink"
          />
        </span>
        <div
          ref={scrollContainer}
          className="flex w-fu overflow-x-auto scroll-container space-x-4 items-center"
        >
          {backgroundAvatars?.map((avatar) => (
            <img
              src={avatar?.image}
              alt="Avatar"
              className="max-w-[70px] max-h-[70px] object-contain rounded-full cursor-pointer"
              onClick={() => {
                onToggle();
                setSelectedAvatar(avatar);
              }}
            />
          ))}
        </div>
        <span
          className="text-gray-400 cursor-pointer ml-2 "
          onClick={scrollRight}
        >
          <FontAwesomeIcon
            icon={faArrowAltCircleRight}
            className="mr-2 text-gray-800 hover:text-vb-pink"
          />
        </span>
      </div>
    </>
  );
};

export default AvatarSlider;
